import React from 'react';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import { cyberpunkColors } from './theme/cyberpunkTheme';

const VcpuMem = ({ stats }) => {
  const memoryInGiB = (stats?.array?.mem || 0) / 1024;
  const vcpu = stats?.array?.vcpu || 'N/A';

  return (
    <Card
      sx={{
        background: 'linear-gradient(145deg, #1a1a24, #0d0d14)',
        border: '1px solid rgba(0, 255, 65, 0.3)',
        borderRadius: 2,
        transition: 'all 0.3s ease',
        height: '100%',
        '&:hover': {
          borderColor: cyberpunkColors.neonGreen,
          boxShadow: '0 0 25px rgba(0, 255, 65, 0.2)',
        },
      }}
    >
      <CardContent>
        <Typography
          sx={{
            fontSize: 11,
            fontFamily: '"Orbitron", sans-serif',
            color: cyberpunkColors.textSecondary,
            textTransform: 'uppercase',
            letterSpacing: '0.1em',
            mb: 1,
          }}
        >
          Instance Specs
        </Typography>
        <Box sx={{ display: 'flex', gap: 3 }}>
          <Box>
            <Typography
              sx={{
                fontSize: 10,
                color: cyberpunkColors.textSecondary,
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
              }}
            >
              vCPU
            </Typography>
            <Typography
              variant="h5"
              sx={{
                fontFamily: '"Orbitron", sans-serif',
                fontWeight: 700,
                color: cyberpunkColors.neonGreen,
                textShadow: '0 0 10px rgba(0, 255, 65, 0.5)',
              }}
            >
              {vcpu}
            </Typography>
          </Box>
          <Box>
            <Typography
              sx={{
                fontSize: 10,
                color: cyberpunkColors.textSecondary,
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
              }}
            >
              Memory
            </Typography>
            <Typography
              variant="h5"
              sx={{
                fontFamily: '"Orbitron", sans-serif',
                fontWeight: 700,
                color: cyberpunkColors.neonGreen,
                textShadow: '0 0 10px rgba(0, 255, 65, 0.5)',
              }}
            >
              {memoryInGiB.toFixed(1)}
              <Typography
                component="span"
                sx={{
                  fontSize: 12,
                  color: cyberpunkColors.textSecondary,
                  ml: 0.5,
                }}
              >
                GiB
              </Typography>
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default VcpuMem;
